import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_2 = { class: "row animated fadeIn" }
const _hoisted_3 = { class: "col-md-12 col-xl-6 p-0" }
const _hoisted_4 = /*#__PURE__*/_createVNode("option", { value: "" }, "ALL", -1)
const _hoisted_5 = { class: "col-12 col-sm-6 col-md-7 col-lg-8  mt-1 mb-1" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 1 D")
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "d-none d-md-inline-block d-lg-inline-block" }, "ay", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 1 W")
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "d-none d-md-inline-block d-lg-inline-block" }, "eek", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 1 M")
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "d-none d-md-inline-block d-lg-inline-block" }, "onth", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 3 M")
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "d-none d-md-inline-block d-lg-inline-block" }, "onths", -1)
const _hoisted_14 = { class: "col-xl-3 col-md-6 col-sm-12 d-flex  mt-1 mb-1" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "mt-2 mr-2 w-25" }, "From:", -1)
const _hoisted_16 = { class: "col-xl-3 col-md-6 col-sm-12 d-flex mt-1" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "mt-2 mr-2 w-25" }, "To:", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = { class: "table-header" }
const _hoisted_20 = { class: "d-flex justify-content-between" }
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fas fa-file-download" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" There are no records to show. ")
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_25 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { key: 3 }
const _hoisted_39 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-sm btn-primary"
}, [
  /*#__PURE__*/_createTextVNode(" Edit order "),
  /*#__PURE__*/_createVNode("i", { class: "fas fa-pen" })
], -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("title", null, "Details"),
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Column = _resolveComponent("Column")
  const _component_IconsCurrency = _resolveComponent("IconsCurrency")
  const _component_router_link = _resolveComponent("router-link")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _withDirectives(_createVNode("select", {
          class: "custom-select col-12 col-sm-6 col-md-5 col-lg-4 mt-1 mb-1",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pairId = $event))
        }, [
          _hoisted_4,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pairs, (item) => {
            return (_openBlock(), _createBlock("option", {
              value: item,
              key: item
            }, _toDisplayString(item), 9, ["value"]))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.pairId]
        ]),
        _createVNode("span", _hoisted_5, [
          _createVNode("button", {
            class: ["btn", { 'btn-primary': _ctx.period == '1D' }],
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.interval('1D')))
          }, [
            _hoisted_6,
            _hoisted_7
          ], 2),
          _createVNode("button", {
            class: ["btn", { 'btn-primary': _ctx.period == '1W' }],
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.interval('1W')))
          }, [
            _hoisted_8,
            _hoisted_9
          ], 2),
          _createVNode("button", {
            class: ["btn", { 'btn-primary': _ctx.period == '1M' }],
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.interval('1M')))
          }, [
            _hoisted_10,
            _hoisted_11
          ], 2),
          _createVNode("button", {
            class: ["btn", { 'btn-primary': _ctx.period == '3M' }],
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.interval('3M')))
          }, [
            _hoisted_12,
            _hoisted_13
          ], 2)
        ])
      ]),
      _createVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_Calendar, {
          modelValue: _ctx.from,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.from = $event)),
          onKeypress: _cache[7] || (_cache[7] = ($event: any) => (_ctx.keypressFilter($event, 'from'))),
          inline: false,
          dateFormat: "yy-mm-dd",
          maxDate: new Date(),
          maxLength: 10
        }, null, 8, ["modelValue", "maxDate"])
      ]),
      _createVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode(_component_Calendar, {
          modelValue: _ctx.to,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.to = $event)),
          onKeypress: _cache[9] || (_cache[9] = ($event: any) => (_ctx.keypressFilter($event, 'to'))),
          inline: false,
          dateFormat: "yy-mm-dd",
          maxDate: new Date(),
          maxLength: 10
        }, null, 8, ["modelValue", "maxDate"])
      ])
    ]),
    _hoisted_18,
    _createVNode(_component_DataTable, {
      loading: _ctx.getStatusOrders === 'fetching',
      class: "table-striped p-datatable-sm",
      value: _ctx.getOrders,
      autoLayout: true,
      paginator: true,
      rows: 10,
      paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
      rowsPerPageOptions: [10, 20, 50],
      currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode("div", null, [
              _withDirectives(_createVNode("button", {
                class: [{ 'btn-primary': _ctx.period == 'Q1' }, "btn mr-2"],
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.interval('Q1'))),
                disabled: _ctx.getStatusOrders === 'fetching'
              }, " Q1 ", 10, ["disabled"]), [
                [_directive_tooltip, 'Jan 1 - Mar 31']
              ]),
              _withDirectives(_createVNode("button", {
                class: [{ 'btn-primary': _ctx.period == 'Q2' }, "btn mr-2"],
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.interval('Q2'))),
                disabled: _ctx.getStatusOrders === 'fetching'
              }, " Q2 ", 10, ["disabled"]), [
                [_directive_tooltip, 'Apr 1 - Jun 30']
              ]),
              _withDirectives(_createVNode("button", {
                class: [{ 'btn-primary': _ctx.period == 'Q3' }, "btn mr-2"],
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.interval('Q3'))),
                disabled: _ctx.getStatusOrders === 'fetching'
              }, " Q3 ", 10, ["disabled"]), [
                [_directive_tooltip, 'Jul 1 - Sep 30']
              ]),
              _withDirectives(_createVNode("button", {
                class: [{ 'btn-primary': _ctx.period == 'Q4' }, "btn mr-2"],
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.interval('Q4'))),
                disabled: _ctx.getStatusOrders === 'fetching'
              }, " Q4 ", 10, ["disabled"]), [
                [_directive_tooltip, 'Oct 1 - Dec 31']
              ])
            ]),
            _createVNode("button", {
              class: "btn btn-primary",
              disabled: 
							_ctx.getStatusOrders === 'fetching' ||
								!_ctx.getOrders ||
								_ctx.getOrders.length === 0
						,
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.downloadXls && _ctx.downloadXls(...args)))
            }, [
              _hoisted_21
            ], 8, ["disabled"])
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _hoisted_22
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "createdAt",
          header: "Date"
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(data.createdAt)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Pair",
          headerClass: "text-center",
          bodyClass: "text-center"
        }, {
          body: _withCtx(({data}) => [
            (_ctx.status == 'success')
              ? (_openBlock(), _createBlock("span", _hoisted_23, [
                  _createVNode(_component_IconsCurrency, {
                    pairType: _ctx.pairType(data.pair),
                    color: true,
                    localCurrency: data.pair.quoteCurrencyId,
                    cryptoCurrency: data.pair.baseCurrencyId,
                    width: '20',
                    height: '20',
                    reverse: data.side !== 1
                  }, null, 8, ["pairType", "localCurrency", "cryptoCurrency", "reverse"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Side",
          headerClass: "text-center",
          bodyClass: "text-right"
        }, {
          body: _withCtx(({data}) => [
            (data.side === 1)
              ? (_openBlock(), _createBlock("span", _hoisted_24, "Buy"))
              : (_openBlock(), _createBlock("span", _hoisted_25, "Sell"))
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "amount",
          header: "Amount",
          headerClass: "text-center",
          sortable: true,
          bodyClass: "text-right"
        }, {
          body: _withCtx(({data}) => [
            (_ctx.status == 'success')
              ? (_openBlock(), _createBlock("span", _hoisted_26, [
                  (
							_ctx.pairType(data.pair) == 'mix' || _ctx.pairType(data.pair) == 'crypto'
						)
                    ? (_openBlock(), _createBlock("span", _hoisted_27, _toDisplayString(_ctx.formatZeros(data.amount, data.pair.baseCurrency.exact)) + " " + _toDisplayString(data.pair.baseCurrencyId), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_28, _toDisplayString(_ctx.formatPrice(data.amount, 2)) + " " + _toDisplayString(data.pair.baseCurrencyId), 1))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "unitPrice",
          header: "Price",
          headerClass: "text-center",
          bodyClass: "text-right"
        }, {
          body: _withCtx(({data}) => [
            (_ctx.status == 'success')
              ? (_openBlock(), _createBlock("span", _hoisted_29, [
                  (_ctx.pairType(data.pair) == 'crypto')
                    ? (_openBlock(), _createBlock("span", _hoisted_30, _toDisplayString(_ctx.formatZeros(data.unitPrice, data.pair.quoteCurrency.exact)) + " " + _toDisplayString(data.pair.quoteCurrencyId), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_31, " $ " + _toDisplayString(_ctx.formatPrice(data.unitPrice, 2)) + " " + _toDisplayString(data.pair.quoteCurrencyId), 1))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "finalPrice",
          header: "Total",
          headerClass: "text-center",
          sortable: true,
          bodyClass: "text-right"
        }, {
          body: _withCtx(({data}) => [
            (_ctx.status == 'success')
              ? (_openBlock(), _createBlock("span", _hoisted_32, [
                  (_ctx.pairType(data.pair) == 'crypto')
                    ? (_openBlock(), _createBlock("span", _hoisted_33, _toDisplayString(_ctx.formatZeros(data.finalPrice, data.pair.quoteCurrency.exact)) + " " + _toDisplayString(data.pair.quoteCurrencyId), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_34, " $ " + _toDisplayString(_ctx.formatPrice(data.finalPrice, 2)) + " " + _toDisplayString(data.pair.quoteCurrencyId), 1))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          style: _ctx.$isAdmin ? '' : 'display: none;',
          header: "Status",
          headerClass: "text-center",
          bodyClass: "text-center"
        }, {
          body: _withCtx(({data}) => [
            (data.status == 3)
              ? (_openBlock(), _createBlock("span", _hoisted_35, "Reversed"))
              : _createCommentVNode("", true),
            (data.status == 2)
              ? (_openBlock(), _createBlock("span", _hoisted_36, "Pending"))
              : _createCommentVNode("", true),
            (data.status == 1)
              ? (_openBlock(), _createBlock("span", _hoisted_37, "Partial Filled"))
              : _createCommentVNode("", true),
            (data.status == 0)
              ? (_openBlock(), _createBlock("span", _hoisted_38, "Filled"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_Column, {
          header: "Actions",
          headerClass: "text-center",
          bodyClass: "text-center"
        }, {
          body: _withCtx(({data}) => [
            (
						_ctx.$isAdmin &&
							data.automaticExecution == false &&
							data.status != 0 &&
							data.status != 3
					)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: {
						name: 'on-behalf-of.home.edit-manual.order',
						params: { orderId: data.uuid },
					}
                }, {
                  default: _withCtx(() => [
                    _hoisted_39
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true),
            (data.uuid)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: {
						name:
							(_ctx.$isAdmin ? 'on-behalf-of.' : '') +
							'account.statement.order.history.detail',
						params: { id: data.uuid },
					}
                }, {
                  default: _withCtx(() => [
                    _hoisted_40
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["loading", "value"])
  ], 64))
}